import { types, Instance } from 'mobx-state-tree';
import { FileUpload } from '../fileUpload';
const { model, string, identifierNumber } = types;

export const InvitationModel = model('EmailTemplateModel', {
  id: identifierNumber,
  emails: string,
  users_file: FileUpload,
});

export type IInvitationModel = Instance<typeof InvitationModel>;
